var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.733.109a1.805 1.805 0 0 0-1.083.976c-.131.283-.165.573-.166 1.44l-.002 1.086h1.771V1.838h10.893v10.9h-1.771v1.774l1.085-.002c1.245-.002 1.611-.116 2.074-.643.476-.542.487-.712.456-6.895l-.028-5.634-.27-.436a1.919 1.919 0 0 0-.664-.658l-.395-.221-5.756-.018C8.195-.01 7.047.01 6.733.11ZM1.097 5.637c-.514.234-.895.71-1.016 1.27-.073.335-.094 2.09-.074 6.098l.028 5.627.246.418c.16.272.393.506.664.665l.418.246 5.624.029c6.242.03 6.349.023 6.912-.486.645-.583.624-.346.597-6.957l-.025-5.908-.266-.377a2.237 2.237 0 0 0-.656-.584l-.39-.206-5.854.002c-5.47.002-5.876.012-6.208.163Zm11.647 7.057v5.45H1.85v-10.9h10.893v5.45Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.99ce383788fc83c0b8b46686dee04141.svg";
export { ForwardRef as ReactComponent };